/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_SquatInputs */

const en_platform_plan_squat = /** @type {(inputs: Platform_Plan_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barbell squat`)
};

const pl_platform_plan_squat = /** @type {(inputs: Platform_Plan_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przysiad ze sztangą`)
};

/**
* | output |
* | --- |
* | "Barbell squat" |
*
* @param {Platform_Plan_SquatInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_squat = /** @type {((inputs?: Platform_Plan_SquatInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_SquatInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_squat(inputs)
	return en_platform_plan_squat(inputs)
});